import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const WarehouseListContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 4px 4px 0 rgb(0 0 0 / 25%);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  .table-container {
    padding: 0 30px;
  }
`;

export const HeaderWrapper = styled.div`
  background-color: #004c83;
  display: flex;
  justify-content: space-between;
  padding: 18px 30px;
`;

export const Title = styled.h2`
  color: white;
  text-align: left;
  width: 100%;
  font-family: "Lato";
  font-size: 22px;
  line-height: 22px;
  margin: 0;
  font-weight: normal;
  text-transform: uppercase;
`;

export const OuterWrapper = styled.div`
  padding: 2rem;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center};
  > div {
    margin-right: 1rem;
  }
`;

export const FilterFlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom:30px;
  align-items: center};
  > div {
    margin-right: 1rem;
  }
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns:${(props) => props.column};
  gap: ${(props) => (props?.gap ? props.gap : "1rem")};
  margin-bottom: 10px;
  opacity: ${(props) => (props?.opacity ? props.opacity : 1)};
  align-items :${(props) =>
    props?.alignItems ? props.alignItems : "self-start"};
}
`;

export const ProductContainer = styled.section`
  width: 100%;
  box-shadow: 2px 2px 2px 2px rgb(0 0 0 / 20%);
  background-color: white;
  padding: 20px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 15px;
  .table-container {
    padding: 0 30px;
  }
`;

export const ContentInfo = styled.span`
  font-size: 14px;
  margin-bottom: 0px;
  color: #474747 !important;
`;

export const ActionButtons = styled.div`
  justify-self: end;
`;

export const ButtonWrapper = styled.div`
  justify-self: end;
`;

export const ButtonData = styled(BaseButton)`
  background: ${(props) => props.colour};
  border: 1px solid ${(props) => props.colour};
  font-weight: normal;
  width: auto;
  margin-right: 5px;
  font-size: 14px;
  font-family: lato;
`;

export const CreateButton = styled(BaseButton)`
  background: #00aeea;
  border: 1px solid #00aeea;
  font-weight: normal;
  width: auto;
  font-size: 16px;
  font-family: lato;
  margin-bottom: 0px;
  line-height: 35px;
  margin-right: -1rem;
`;

export const BlockRow = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  padding: 0 10px;
  opacity: ${(props) => (props?.opacity ? props.opacity : 1)};
}
`;

export const SliderGridRow = styled.div`
  display: grid;
  grid-template-columns:${(props) => props.column};
  margin-top: 10px;
  gap: 1.25rem;
}
`;

export const TransportDetail = styled.div`
  font-size: 14px;
  font-style: italic;
  color: #767676 !important;
`;

export const FilterOuter = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 74%;
`;

export const GlobalSearch = styled.div`
  display: flex;
  align-items: center;
`;

export const ProductLabel = styled.div`
  color: #474747 !important;
  font-size: 14px;
  font-weight: 400;
`;

export const TruckCountLabel = styled.div`
  font-size: 60px;
  color: #00aeea;
  font-weight: 700;
  opacity: ${(props) => (props?.opacity ? props.opacity : 1)};
  color: ${(props) => props?.color};
  text-align: center;
`;

export const TruckLabel = styled.div`
  opacity: ${(props) => (props?.opacity ? props.opacity : 1)};
  color: ${(props) => props?.color};
  font-size: 18px;
  font-weight: 700;
  margin-top: 5px;
  margin-bottom: 10px;
`;

export const PriceLabel = styled.div`
  opacity: ${(props) => (props?.opacity ? props.opacity : 1)};
  color: ${(props) => props?.color};
  font-size: 14px;
`;

export const HorizontalRow = styled.div`
  border: 1px solid rgba(10, 73, 134, 0.3);
  width: 100%;
`;
